import { LAYOUTS } from "@voltmoney/types";
import { ROUTE } from "../../routes";
import { WIDGET } from "@voltmoney/schema";
import { ACTION } from "./types";
import { goBack } from "./action";
export const template = (height) => {
    return {
        layout: {
            id: ROUTE.PRODUCT_DETAILS_PAGE_MF,
            type: LAYOUTS.LIST,
            style: {
                isPartnerPlatform: true
            },
            widgets: [{
                    id: 'productDetailsScreen',
                    type: WIDGET.PRODUCT_DETAILS_SCREEN_DC,
                }],
        },
        datastore: {
            productDetailsScreen: {
                height,
                backAction: {
                    payload: {},
                    type: ACTION.GO_BACK,
                    routeId: ROUTE.PRODUCT_DETAILS_PAGE_MF,
                }
            }
        },
    };
};
export const ProductDetailsPage = {
    onLoad: async ({ getHeight }) => {
        return Promise.resolve(template(getHeight()));
    },
    actions: {
        [ACTION.GO_BACK]: goBack,
    },
};
